import { SelectInput } from "lib/core/components/forms"
import PropTypes from "prop-types"
import "./ContentMethodFileType.css"

const selectProps = {
  placeholder: "Select filetype",
  options: [
    { value: "Document", label: "a document", icon: "file-text" },
    { value: "Image", label: "an image", icon: "file-image" },
    { value: "Video", label: "a video", icon: "file-video" },
    { value: "Archive", label: "a zipped file", icon: "file-zipped" },
    { value: "", label: "anything", icon: "file" }
  ]
}
// valueRenderer: ({ icon, label })->
//   <span className="ContentMethod__FileType__Value">
//     <Pathicon icon={icon} /> {label}
//   </span>
// optionRenderer: ({ icon, label })->
//   <div className="ContentMethod__FileType__Option">
//     <Pathicon icon={icon} /> {label}
//   </div>

const ContentMethodFileType = function (props) {
  const { instructions, onChange, value } = props

  return (
    <div className="ContentMethod__FileType">
      <span>{instructions} </span>
      <SelectInput
        {...Object.assign({}, selectProps, {
          onChange: (value) => onChange(value, props),
          value: value,
          hideStatus: true,
          hideLabel: true,
          autosize: true,
          inline: true
        })}
      />
    </div>
  )
}

ContentMethodFileType.displayName = "ContentMethodFileType"
ContentMethodFileType.propTypes = {
  instructions: PropTypes.string.isRequired
}
ContentMethodFileType.defaultProps = {
  instructions: "The learner should submit"
}

export default ContentMethodFileType
